export default "__VITE_ASSET__yxeEr6e3__"